module.exports = __webpack_public_path__ + "img/currency-pound.cd462963.svg";